module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background-color": "#ffffff"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "height": "100vh",
      "text-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-2em"
    }
  }, [_c('a', {
    staticClass: "header-nav-back",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "16px",
      "color": "#ffffff"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "center",
      "margin": "0.61em 0",
      "margin-bottom": "3em",
      "padding-top": "1em"
    }
  }, [_c('p', [_vm._v("Order Details")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-0.31em"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.product.product_name))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.menu_tab_inner_view['confirmOrder']) ? _c('div', [_c('div', {
    staticClass: "row card-box-o",
    staticStyle: {
      "text-align": "left",
      "color": "#ffffff"
    }
  }, [_c('h3', [_c('span', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])]), _vm._v(" Order Confirmation")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_ref))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding": "2em"
    }
  }, [(_vm.set_order_data.order_items && (Object.keys(_vm.set_order_data.order_items).length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, _vm._l((_vm.set_order_data.order_items), function(product_item, index) {
    return _c('div', {
      staticClass: "card col-xs-12"
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-square",
      staticStyle: {
        "width": "100px",
        "height": "95px"
      }
    }, [(product_item.product_item_group_image) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product_item.product_item_group_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product_item.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product_item.product_item_price_f))])]), _vm._v("\r\n                      Quantity:"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (product_item.product_item_order_quantity),
        expression: "product_item.product_item_order_quantity"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (product_item.product_item_order_quantity)
      },
      on: {
        "change": function($event) {
          _vm.setOrderQuantity(product_item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          product_item.product_item_order_quantity = $event.target.value
        }
      }
    })])])])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "1em",
      "padding-bottom": "2em"
    }
  }, [(_vm.menu_tab_inner_view['confirmOrder']) ? _c('div') : _vm._e()])]) : _c('div', [_c('div', {
    staticClass: "card pb_img_box"
  }, [((_vm.product.product_images && (_vm.product.product_images.length > 0)) && (_vm.product.product_images[0].product_image != '' && _vm.product.product_images[0].product_image != 'error')) ? _c('img', {
    staticClass: "pb_img",
    attrs: {
      "src": _vm.img_product_url + _vm.product.product_images[0].product_image,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "pb_img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%",
      "margin-left": "-0.11em",
      "border-left": "#ffffff solid"
    },
    attrs: {
      "id": "shareBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "max-height": "75vh",
      "overflow": "scroll",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "z-box",
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "border-radius": "35px 35px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "200px",
      "padding": "2em",
      "text-align": "left"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [(_vm.set_view_box == '') ? _c('div', {
    staticClass: "row"
  }, [(((!_vm.product.product_addons) || (_vm.product.product_addons && (_vm.product.product_addons.length == 0)))) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(0, 'sub', 0, _vm.product_item, 0)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 0.61em"
    }
  }, [_vm._v(_vm._s(_vm.product_item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(0, 'add', 0, _vm.product_item, 0)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _c('div', [_c('h3', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Your Order")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "width": "120%",
      "margin": "0",
      "padding": "0",
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "col-xs-2 card-avatar-square",
    staticStyle: {
      "width": "80px",
      "height": "80px"
    }
  }, [(_vm.product.product_images && (Object.keys(_vm.product.product_images).length > 0)) ? _c('img', {
    attrs: {
      "src": _vm.product.product_images[0].product_image
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin-left": "0",
      "margin-top": "0.5em"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.product.product_name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5",
    staticStyle: {
      "margin-top": "1.4em"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(0, 'sub', 0, _vm.product_item, 0)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 0.61em"
    }
  }, [_vm._v(_vm._s(_vm.product_item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(0, 'add', 0, _vm.product_item, 0)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v("+")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_addons && (_vm.product.product_addons.length > 0)) ? _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "128%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "600"
    }
  }, [_vm._v("you can also add these to your order")]), _vm._v(" "), _vm._l((_vm.product.product_addons), function(product, index) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "col-xs-2 card-avatar-square",
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "margin": "0",
        "padding": "0",
        "margin-right": "0"
      }
    }, [(product.product_images && (Object.keys(product.product_images).length > 0)) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_c('b', [_vm._v("Add ")]), _vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x",
      staticStyle: {
        "color": "#ff0000",
        "font-weight": "600"
      }
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "width": "39.87%"
      }
    }, [_c('div', {}, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(product.product_items[0], index, 0)
        }
      }
    }, [_vm._m(2, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(product.product_items[0], index, 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setDeliveryLocation') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setDeliveryLocation"
    }
  }, [(Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', [_vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_delivery_location),
        expression: "set_order_delivery_location"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": location.business_delivery_option_id,
        "checked": _vm._q(_vm.set_order_delivery_location, location.business_delivery_option_id)
      },
      on: {
        "click": function($event) {
          _vm.setOrderDeliveryLocation(location)
        },
        "__c": function($event) {
          _vm.set_order_delivery_location = location.business_delivery_option_id
        }
      }
    })]), _vm._v("\r\n                        " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                      ")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setContactDetails') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setContactDetails"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Order Contact Details")]), _vm._v(" "), (_vm.user.user_id && (_vm.user.user_id > 0)) ? _c('div', [_c('p', [_vm._v("Review contact details")]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), ((_vm.set_payment_mode == 1) && (_vm.user.user_email == '')) ? _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]) : _vm._e()]) : _c('div', [(_vm.menu_tab_inner_view['showUserDetails']) ? _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]) : _c('div', [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('showUserDetails')
      }
    }
  }, [_vm._v("Ok")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setPaymentOptions') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentOptions"
    }
  }, [(_vm.menu_tab_inner_view['showOrderPaymentConfirmation']) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentSuccess"
    }
  }, [_c('p', [_vm._v("Payment Made")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn card-link",
    attrs: {
      "href": '/placed/order/' + _vm.order.order_no
    }
  }, [_vm._v("View Order")])]) : _c('div', [_vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Payment Method")]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "4")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payBank')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "4"
      }
    }
  })]), _vm._v("\r\n                        Pay to Bank")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payBank"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Bank: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Number: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_number))])])])]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "1")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payDirect')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "1"
      }
    }
  })]), _vm._v("\r\n                        Pay to Direct")]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', [(_vm.data_processing_messages.mode_err) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_messages.mode_err))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.setMakeOrder(_vm.set_payment_mode)
      }
    }
  }, [_vm._v("Place Order")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 0.61em"
    }
  }, [_vm._v("900")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.product.product_addons && (_vm.product.product_addons.length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setOptions');
        _vm.set_view_box = 'setAddons'
      }
    }
  }, [_c('ul', {
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, _vm._l((_vm.product.product_addons), function(product, index) {
    return _c('li', [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "width": "50px",
        "height": "45px"
      }
    }, [(product.product_images && (Object.keys(product.product_images).length > 0)) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "none",
        "padding": "3px",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), (_vm.checkOrderProductAddons(product)) ? _c('div', [_c('input', {
      attrs: {
        "checked": "true",
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setOrderProductAddons(product)
        }
      }
    }), _vm._v(" Added\r\n                            ")]) : _c('div', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setOrderProductAddons(product)
        }
      }
    }), _vm._v(" Add")])])])])
  }))])])]) : _c('div', {
    staticStyle: {
      "height": "0em"
    }
  }), _vm._v(" "), (Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "background-color": "#f5e61d"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_vm._v("select")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "position": "fixed",
      "background-color": "#ffffff",
      "bottom": "0",
      "width": "100%",
      "padding-left": "1.81em",
      "padding-top": "6px",
      "margin-top": "10px",
      "border-top": "1px solid #eee"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "x-totals"
  }, [(_vm.set_order_total_amount && (_vm.set_order_total_amount > 0)) ? _c('h3', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.set_view_box == 'setPaymentOptions') ? _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setContactDetails'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])])]) : (_vm.set_view_box == 'setContactDetails') ? _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setDeliveryLocation'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setPaymentOptions'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])]) : (_vm.set_view_box == 'setDeliveryLocation') ? _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setContactDetails'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])]) : _c('div', [_c('div', [_c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setDeliveryLocation'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "border": "none",
      "width": "100%",
      "bottom": "0em",
      "margin": "0",
      "padding": "0 2em",
      "padding-top": "1.2em",
      "padding-right": "0",
      "background": "#ffffff",
      "z-index": "1"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "auto",
      "padding": "0.1em",
      "background-color": "rgba(0, 0, 0, 0)",
      "border-top": "none",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "x-totals"
  }, [(_vm.set_order_total_amount && (_vm.set_order_total_amount > 0)) ? _c('h3', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "x-cta-btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.processMakeOrder();
        _vm.toggleSingleComponent('shareBox');
      }
    }
  }, [_vm._v("Order Now")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h4', [_vm._v("Quantity")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Payment")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send to:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payDirect"
    }
  }, [_c('p', [_vm._v("Pay with your Credit/ATM card")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', [_vm._v("Quantity")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._v("Add to Order"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "0.05em",
      "font-size": "13px"
    }
  }, [_vm._v("items you should buy with this order")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', [_vm._v("Delivery Location")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fef2121a"}!./src/pages/MakeOrder/template.html
// module id = 641
// module chunks = 0